<template>
  <div class="header_wrapper">
    <DownloadAppStickyHeader v-if="!isMobileMenuOpen" />
    <div class="header_container">
      <StrapiPublicHeader
        :userData="userData"
        :languages="languages"
        :strapiSlug="'base-all-page-info'"
        :strapiUrl="'https://strapi.emcd.io'"
        :signInBtn="signInBtn"
        :registrationBtn="registrationBtn"
        @updateLang="handleLocaleChange"
        @logout="store.dispatch('user/logout')"
        @mobile-menu-click="handleMobileMenuClick"
      />
    </div>
  </div>
</template>

<script setup lang="js">
import { computed, onMounted, ref } from "vue";
import StrapiPublicHeader from "@emcd-widgets/strapi-public-header";
import DownloadAppStickyHeader from "../../DownloadAppStickyHeader/ui/DownloadAppStickyHeader.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import CONFIG from "@/app/config";
import moment from "moment/moment";
import "moment/locale/en-gb";
import "moment/locale/ru";

defineOptions({
  name: "Header",
  components: {
    DownloadAppStickyHeader,
  },
});

const { locale } = useI18n();
const store = useStore();

const { t } = useI18n();

const isMobileMenuOpen = ref(false);

const handleMobileMenuClick = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const signInBtn = computed(() => {
  return {
    link: `${CONFIG.AUTH_URL}?redirect=${window.location.href}&utm_source=explorer`,
    label_text: t("Sign in"),
  };
});

const registrationBtn = computed(() => {
  return {
    link: `${CONFIG.REGISTRATION_URL}?redirect=${window.location.href}&utm_source=explorer`,
    label_text: t("explorer.header.create_account"),
  };
});

const userData = computed(() =>
  store.getters["user/getUserData"]
    ? store.getters["user/getUserData"].userData
    : null,
);
const isPossibleAuthorize = computed(
  () => store.getters["user/getIsPossibleAuthorize"],
);

const languages = ref([
  {
    abbr: "ru",
    name: "Русский",
    flagImg: "🇷🇺",
  },
  {
    abbr: "en",
    name: "English",
    flagImg: "🇬🇧",
  },
  // {
  //   abbr: "pt",
  //   name: "Português",
  //   flagImg: "🇧🇷",
  // },
  // {
  //   abbr: "es",
  //   name: "Español",
  //   flagImg: "🇪🇸",
  // },
  // {
  //   abbr: "fr",
  //   name: "Français",
  //   flagImg: "🇫🇷",
  // },
]);

const handleLocaleChange = (newLocale) => {
  moment.locale(newLocale === "ru" ? "ru" : "en-gb");
  locale.value = newLocale;
  document.cookie = `lang=${newLocale}; path=/; max-age=${30 * 24 * 60 * 60}`;
};

onMounted(async () => {
  if (isPossibleAuthorize.value) {
    // A failed refresh (expired session, suspended account) leaves the header
    // in the anonymous state: the login redirect is disabled in main.js via
    // AuthService.setLoginRedirect(false), user/authenticate resets the user.
    store.dispatch("user/authenticate").catch(() => {});
  }
});
</script>

<style lang="scss" scoped>
.header {
  @media (max-width: 768px) {
    position: relative;
  }
  &_wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    height: 76px;
    width: 100%;
  }

  &_container {
    position: static;
    top: 12px;
    left: 16px;
    right: 16px;
    border-radius: 16px;
    height: 64px;
    width: calc(100% - 32px);

    @media (max-width: 768px) {
      width: 100%;
    }
  }
}
</style>
